import { render, staticRenderFns } from "./BaseFuturo.vue?vue&type=template&id=48cf36a3&"
import script from "./BaseFuturo.vue?vue&type=script&lang=js&"
export * from "./BaseFuturo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports